<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="page-title">
          <div class="row">
            <div class="col-6">
              <h3></h3>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body add-post">
                    <div class="row my-3">
                      <div class="w-full ">
                        <!-- Mostrar: dropdown para seleccionar usuarios por página -->
                        <div class="d-flex align-items-center mb-3">
                          <span class="me-2">Mostrar:</span>
                          <select 
                            v-model="usersPerPage" 
                            @change="resetPagination"
                            class="form-select w-auto"
                          >
                            <option :value="10">10</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                          </select>
                          <span class="ms-2">registros</span>
                        </div>
                        <!-- Container para botón y filtros -->
                        <div class="flex flex-col md:flex-row md:justify-between md:items-center w-full mb-4 gap-3">
                          <button @click="goToUserForm"  class="px-4 py-2 bg-[#FF4265] text-white text-sm font-medium rounded-md hover:bg-[#e03a5f] transition-colors duration-200 mb-2 md:mb-0">
                            <span class="custom-create-btn-text">Crear Prospecto</span>
                          </button>

                          <!-- Botón 2 -->
                          <button @click="confirm_notify" class="custom-create-btn">
                            <span class="custom-create-btn-text">Notificar Asesores</span>
                          </button>

                          <!-- Botón toggle filtros (solo mobile) -->
                          <button 
                            @click="showFilters = !showFilters"
                            class="md:hidden px-4 py-2 bg-pink-500 text-white rounded-md flex items-center gap-2 justify-center"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                            </svg>
                            Filtros
                          </button>

                          <!-- Buscador -->
                          <div class="filters-wrapper w-full md:w-auto" :class="{ 'hidden md:flex': !showFilters, 'flex': showFilters }">
                            <div class="flex flex-col md:flex-row gap-2 w-full md:w-auto">
                              <input
                                type="text"
                                class="w-64 px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                                placeholder="Buscar"
                                v-model="searchQuery"
                              />   
                            </div> 
                          </div> 
                        </div>    
                    </div>
                    <div class="row my-3">
                      <div class="w-full ">
                      </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm" id="t_usuarios">
                          <thead class="bg-gray-50 text-gray-700 uppercase text-xs font-['Poppins']">
                              <tr>
                                  <th class="py-3 px-6 text-style-custom text-left">ID</th>
                                  <th class="py-3 px-6 text-style-custom text-left">Nombre</th>
                                  <th class="py-3 px-6 text-style-custom text-left">Apellido</th>
                                  <th class="py-3 px-6 text-style-custom text-left">Estatus</th>
                                  <th class="py-3 px-6 text-style-custom text-left">Compañia</th>
                                  <th class="py-3 px-6 text-style-custom text-left">Acción</th>
                              </tr>
                          </thead>
                          <tbody class="text-gray-700 text-sm divide-y divide-gray-200">
                            <tr v-for="user in filteredUsers" :key="user.id" 
                                :class="{'hover:bg-gray-50 transition-colors duration-150': user.status === 'delete' || user.status === 'Desactivado'}">
                              <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ user.id }}</td>
                              <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ user.name }}</td>
                              <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ user.last_name }}</td>
                              <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ user.status.name }}</td>
                              <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ user.company.name }}</td>
                              <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                <div class="relative inline-flex items-center" ref="menuContainer">
                                  <!-- Icono de menú -->
                                  <div 
                                    class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-200"
                                    @click.stop="user.status !== 'Desactivado' && user.status !== 'delete' ? toggleMenu(user.id) : null"
                                  >
                                    <svg 
                                      xmlns="http://www.w3.org/2000/svg" 
                                      width="17" 
                                      height="4" 
                                      viewBox="0 0 17 4" 
                                      fill="none" 
                                      class="cursor-pointer"
                                      :class="{'cursor-not-allowed': user.status === 'Desactivado' || user.status === 'delete'}"
                                    >
                                      <path 
                                        fill-rule="evenodd" 
                                        clip-rule="evenodd" 
                                        d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" 
                                        fill="#FF4265"
                                      />
                                    </svg>
                                  </div>

                                  <!-- Menú desplegable -->
                                  <div 
                                    v-show="menuVisible === user.id" 
                                    class="absolute right-0 bg-white border shadow-lg mt-1 w-48 z-10"
                                    :class="{
                                    'bottom-full mb-1': filteredUsers.length > 1 && filteredUsers.indexOf(user) === filteredUsers.length - 1,
                                    'top-full mt-1': filteredUsers.length === 1 || filteredUsers.indexOf(user) < filteredUsers.length - 1
                                  }">
                                    <ul class="py-1">
                                      <!-- Ver perfil -->
                                      <li 
                                        v-if="user.status !== 'Desactivado' && user.status !== 'delete'" 
                                        class="px-4 py-2.5 flex items-center hover:bg-gray-50 cursor-pointer text-gray-700 text-sm font-['Poppins'] transition-colors duration-150" 
                                        @click="profileUser(user.id)"
                                      >
                                        Ver Perfil
                                      </li>
                                      
                                      <!-- Editar -->
                                      <li 
                                        v-if="user.status !== 'Desactivado' && user.status !== 'delete'" 
                                        class="px-4 py-2.5 flex items-center hover:bg-gray-50 cursor-pointer text-gray-700 text-sm font-['Poppins'] transition-colors duration-150"
                                        @click="editUser(user.id)"
                                      >
                                        Editar
                                      </li>
                                      
                                      <!-- Bloquear -->
                                      <li 
                                        v-if="user.status !== 'Desactivado' && user.status !== 'delete'" 
                                        class="px-4 py-2.5 flex items-center hover:bg-gray-50 cursor-pointer text-gray-700 text-sm font-['Poppins'] transition-colors duration-150"
                                        @click="block_user(user.id)"
                                      >
                                        Bloquear
                                      </li>
                                      
                                      <!-- Reenviar correo -->
                                      <li 
                                        v-if="user.status !== 'Desactivado' && user.status !== 'delete'" 
                                        class="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer text-green-600"
                                        @click="reenviar_email(user.id)"
                                      >
                                        Reenviar correo
                                      </li>
                                      
                                      <!-- Desactivar -->
                                      <li 
                                        v-if="user.status !== 'Desactivado' && user.status !== 'delete'" 
                                        class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" 
                                        @click="delete_user(user.id)"
                                      >
                                        Desactivar
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>

                        </table>
                        <div class="flex justify-between items-center w-full">
                          <div class="hidden md:block w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal">
                            Mostrando {{ currentPage }} de {{ totalPages }}
                          </div>
                          <!-- Controles de paginación -->
                          <div class="flex justify-center md:justify-end items-center gap-1 mt-6 py-4">
                            <!-- Botón Anterior -->
                            <button 
                              @click="changePage(currentPage - 1)" 
                              :disabled="currentPage === 1"
                              class="px-3 py-2 border border-[#FFD8DF] bg-white text-[#FF4265] text-sm font-['Poppins'] rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 hover:bg-[#FFF5F7] disabled:hover:bg-gray-100 min-w-[40px]"
                            >
                              <span class="hidden md:inline">Anterior</span>
                              <span class="md:hidden">&lt;</span>
                            </button>

                            <!-- Números de página -->
                            <span
                              v-for="(pageNumber, index) in visiblePages"
                              :key="pageNumber === '...' ? `dots-${index}` : `page-${pageNumber}`"
                              class="flex items-center"
                            >
                              <button
                                v-if="pageNumber !== '...'"
                                @click="changePage(pageNumber)"
                                class="px-3 py-2 border border-[#FFD8DF] text-sm font-['Poppins'] rounded transition-colors min-w-[40px]"
                                :class="pageNumber === currentPage 
                                  ? 'bg-[#FF4265] text-white border-[#FF4265] font-medium' 
                                  : 'bg-white text-[#FF4265] hover:bg-[#FFF5F7]'"
                              >
                                {{ pageNumber }}
                              </button>

                              <span
                                v-else
                                class="px-2 text-gray-500 font-['Poppins']"
                              >
                                ...
                              </span>
                            </span>

                            <!-- Botón Siguiente -->
                            <button 
                              @click="changePage(currentPage + 1)" 
                              :disabled="currentPage >= totalPages"
                              class="px-3 py-2 border border-[#FFD8DF] bg-white text-[#FF4265] text-sm font-['Poppins'] rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 hover:bg-[#FFF5F7] disabled:hover:bg-gray-100 min-w-[40px]"
                            >
                              <span class="hidden md:inline">Siguiente</span>
                              <span class="md:hidden">&gt;</span>
                            </button>
                          </div>
                        </div>
                        <div v-if="successMessage" style="color: green; margin-top: 10px;">
                          {{ successMessage }}
                        </div>   
                    </div>
                    <!-- Vista Mobile - Cards (después del cierre de </table>) -->
                    <div class="lg:hidden flex flex-col gap-4 mt-4">
                      <div v-for="user in filteredUsers" :key="user.id"  
                        class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm"
                        :class="{'hover:bg-gray-50 transition-colors duration-150': user.status === 'delete' || user.status === 'Desactivado'}">
                      
                        <!-- Header -->
                        <div class="flex justify-between items-start pb-3 mb-3 border-b border-gray-100">
                          <div class="flex-1 space-y-2">
                            <div class="text-gray-900 font-medium text-base font-['Poppins']">{{ user.name }} {{ user.last_name }}</div>
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium font-['Poppins']" 
                              :class="{ 
                                //'bg-yellow-100 text-yellow-800': company.status === 'Bloqueado',
                                //'bg-red-100 text-red-800': company.status === 'Desactivado',
                                //'bg-green-100 text-green-800': company.status === 'Activo'
                              }">
                              {{ user.status.name }}
                            </span>
                          </div>
                            
                          <!-- Menú 3 puntos -->
                          <div class="relative" ref="menuContainer">
                            <div class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-100 transition-colors"
                              @click="toggleMenu(user.id)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="4" viewBox="0 0 17 4" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" fill="#FF4265"/>
                              </svg>
                            </div>
                            <div v-show="menuVisible === user.id" 
                              class="absolute right-0 mt-2 bg-white border border-gray-200 shadow-lg w-48 z-50 rounded-lg overflow-hidden">
                              <ul class="py-1 divide-y divide-gray-100">
                                <li class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] transition-colors" @click="profileUser(user.id)">Ver Perfil</li>
                                <li class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] transition-colors" @click="editUser(user.id)">Editar</li>
                                <!-- Bloquear -->
                                <li 
                                  v-if="user.status !== 'Desactivado' && user.status !== 'delete'" 
                                  class="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer text-red-600"
                                  @click="block_user(user.id)"
                                >
                                  Bloquear
                                </li>
                                      
                                <!-- Reenviar correo -->
                                <li 
                                  v-if="user.status !== 'Desactivado' && user.status !== 'delete'" 
                                  class="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer text-green-600"
                                  @click="reenviar_email(user.id)"
                                >
                                  Reenviar correo
                                </li>
                                      
                                <!-- Desactivar -->
                                <li 
                                  v-if="user.status !== 'Desactivado' && user.status !== 'delete'" 
                                  class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" 
                                  @click="delete_user(user.id)"
                                >
                                  Desactivar
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                          
                        <!-- Body -->
                        <div class="space-y-2">
                          <div class="flex justify-between items-center py-1">
                            <span class="text-gray-500 text-sm font-medium font-['Poppins']">Inmobiliaria:</span>
                            <span class="text-gray-900 text-sm font-['Poppins'] text-right max-w-[60%] break-words">{{ user.company.name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <BlockUser_modal
                      :isVisible="showBlockModal"
                      @confirm="confirmBlock"
                      @cancel="closeModal"
                    />
                    <NotifyAdvisor_Modal
                      :isVisible="showNotifyModal"
                      @confirm="confirmNotify"
                      @cancel="closeModal"
                    />
                    <div v-if="showDeleteModal" class="modal-overlay" style="display: flex; justify-content: center; align-items: center; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5);">
                      <div class="modal-content" style="display: flex; flex-direction: column; width: 623px; padding-bottom: 26px; background: white; border-radius: 8px;">
                        <!-- Modal Header -->
                        <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; padding: 16px;">
                          <h3>¿Seguro que deseas desactivar a este asesor?</h3>
                          <button type="button" class="btn-close" @click="closeModal" style="background: none; border: none; font-size: 20px;">×</button>
                        </div>
                        <!-- Modal Body -->
                        <div class="modal-header" style="padding: 16px; display: flex; align-items: center; gap: 4px; justify-content: flex-start;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style="margin-right: 2px;">
                                <path d="M6.875 6.875C7.04076 6.875 7.19973 6.94085 7.31694 7.05806C7.43415 7.17527 7.5 7.33424 7.5 7.5V15C7.5 15.1658 7.43415 15.3247 7.31694 15.4419C7.19973 15.5592 7.04076 15.625 6.875 15.625C6.70924 15.625 6.55027 15.5592 6.43306 15.4419C6.31585 15.3247 6.25 15.1658 6.25 15V7.5C6.25 7.33424 6.31585 7.17527 6.43306 7.05806C6.55027 6.94085 6.70924 6.875 6.875 6.875ZM10 6.875C10.1658 6.875 10.3247 6.94085 10.4419 7.05806C10.5592 7.17527 10.625 7.33424 10.625 7.5V15C10.625 15.1658 10.5592 15.3247 10.4419 15.4419C10.3247 15.5592 10.1658 15.625 10 15.625C9.83424 15.625 9.67527 15.5592 9.55806 15.4419C9.44085 15.3247 9.375 15.1658 9.375 15V7.5C9.375 7.33424 9.44085 7.17527 9.55806 7.05806C9.67527 6.94085 9.83424 6.875 10 6.875ZM13.75 7.5C13.75 7.33424 13.6842 7.17527 13.5669 7.05806C13.4497 6.94085 13.2908 6.875 13.125 6.875C12.9592 6.875 12.8003 6.94085 12.6831 7.05806C12.5658 7.17527 12.5 7.33424 12.5 7.5V15C12.5 15.1658 12.5658 15.3247 12.6831 15.4419C12.8003 15.5592 12.9592 15.625 13.125 15.625C13.2908 15.625 13.4497 15.5592 13.5669 15.4419C13.6842 15.3247 13.75 15.1658 13.75 15V7.5Z" fill="#FF4265"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.125 3.75C18.125 4.08152 17.9933 4.39946 17.7589 4.63388C17.5245 4.8683 17.2065 5 16.875 5H16.25V16.25C16.25 16.913 15.9866 17.5489 15.5178 18.0178C15.0489 18.4866 14.413 18.75 13.75 18.75H6.25C5.58696 18.75 4.95107 18.4866 4.48223 18.0178C4.01339 17.5489 3.75 16.913 3.75 16.25V5H3.125C2.79348 5 2.47554 4.8683 2.24112 4.63388C2.0067 4.39946 1.875 4.08152 1.875 3.75V2.5C1.875 2.16848 2.0067 1.85054 2.24112 1.61612C2.47554 1.3817 2.79348 1.25 3.125 1.25H7.5C7.5 0.918479 7.6317 0.600537 7.86612 0.366117C8.10054 0.131696 8.41848 0 8.75 0L11.25 0C11.5815 0 11.8995 0.131696 12.1339 0.366117C12.3683 0.600537 12.5 0.918479 12.5 1.25H16.875C17.2065 1.25 17.5245 1.3817 17.7589 1.61612C17.9933 1.85054 18.125 2.16848 18.125 2.5V3.75ZM5.1475 5L5 5.07375V16.25C5 16.5815 5.1317 16.8995 5.36612 17.1339C5.60054 17.3683 5.91848 17.5 6.25 17.5H13.75C14.0815 17.5 14.3995 17.3683 14.6339 17.1339C14.8683 16.8995 15 16.5815 15 16.25V5.07375L14.8525 5H5.1475ZM3.125 3.75V2.5H16.875V3.75H3.125Z" fill="#FF4265"/>
                            </svg>
                            <p style="margin:0;">Al desactivar a un asesor, no se eliminan los inmuebles que administra.</p>
                        </div>
                        <!-- Modal Footer -->
                        <div class="modal-footer" style="display: flex; justify-content: flex-end; align-items: center; gap: 10px; padding: 10px 16px;">
                          
                          <button @click="closeModal" style="padding: 10px 16px; border-radius: 4px; background: var(--Neutral-Ne-Medium-Weak, #737373); color: #fff; border: none;">
                            Cancelar
                          </button>
                          <button @click="confirmDelete" style="padding: 10px 16px; border-radius: 4px; background: var(--Primary-Primary, #FF4265); color: #fff; border: none;">
                            Confirmar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-if="successMessage" class="user-alert">
                        <div class="user-alert-content">
                            <div class="user-alert-text">
                                {{ successMessage }}
                            </div>
                        </div>
                        <div class="w-4 h-4 relative"></div>
                    </div>
                </div>
                <head>
                  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                </head>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>


<script setup>
    import { ref, onMounted, onUnmounted , watch} from 'vue';
    import { useRouter } from 'vue-router';
    import axios from 'axios';
    import { computed } from "vue";
    import { useStore } from 'vuex';
    import BlockUser_modal from './modal/BlockUser_modal.vue';
    import 'vue-toastification/dist/index.css';
    import Loader from '@/components/loaderComponent.vue';
    import NotifyAdvisor_Modal from './modal/NotifyAdvisor_Modal.vue';



    // Referencias y estado
    const isLoading = ref(true); // Inicializamos isLoading
    const users = ref([]);
    const usersPerPage = ref(10);  // Número de usuarios por página
    const searchQuery = ref("");  // Para almacenar el término de búsqueda
    const selectedRole = ref(''); // Rol seleccionado
    const menuVisible = ref(null);
    const store = useStore();
    const currentPage = ref(1);
    let session = computed(() => store.getters.getUserSession);
    const router = useRouter();
    const showBlockModal = ref(false); // Controla la visibilidad del modal
    const showDeleteModal = ref(false); // Controla la visibilidad del modal
    const showNotifyModal = ref(false);
    const showFilters = ref(false);
    const selectedUserId = ref(null);
    const successMessage = ref(''); // Esta variable se utilizará para mostrar el mensaje
    //const selectedRoles = ref([]); // Aquí guardaremos los roles seleccionados

    // Métodos

    const fetchUsers = async () => {
        isLoading.value = true;
        try {
            let options = {
                headers: {
                    'Authorization': `Bearer ${session.value.token_api}`
                }
            };

            const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/leads`, options);
            console.log(response);
            
            // Verifica si los datos están en response.data.resp
            if (response.data && Array.isArray(response.data.resp)) {
                // Traducir el estado de cada usuario
                users.value = response.data.resp.map(user => ({
                    ...user,
                }));
            } else {
                users.value = [];
                console.error("La respuesta no contiene una lista de usuarios válida.");
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                store.dispatch('clearUserSession');
            }
            console.error("Error al obtener los usuarios", error);
            users.value = [];
        } finally {
            isLoading.value = false;
        }
    };

    const resetPagination = () => {
      currentPage.value = 1; // Reset to first page
    };

    // Cambiar la página
    const changePage = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages.value) {
        currentPage.value = newPage;
        }
    };

    const visiblePages = computed(() => {
      const total = totalPages.value;
      const current = currentPage.value;

      const pages = []; // ✅ declarar primero

      if (total <= 4) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
        return pages;
      }

      pages.push(1);

      if (current > 3) {
        pages.push('...');
      }

      const start = Math.max(2, current - 1);
      const end = Math.min(total - 1, current + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (current < total - 2) {
        pages.push('...');
      }

      pages.push(total);

      return pages;
    });

    const filterUsers = () => {
        const query = searchQuery.value.toLowerCase();
        filteredUsers.value = users.value.filter(user => {
        const matchesRole = selectedRole.value ? user.role === selectedRole.value : true;
        console.log(selectedRole.value)
        const matchesSearch =
            user.name.toLowerCase().includes(query) ||
            user.email.toLowerCase().includes(query);
        return matchesRole && matchesSearch;
        });
    };

    // Reacciones a cambios en `searchQuery` o `selectedRole`
    watch([searchQuery, selectedRole], filterUsers);

    const filteredUsers = computed(() => {
        let filtered = users.value.filter(user =>
        user.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        user.email.toLowerCase().includes(searchQuery.value.toLowerCase())
        );

        if (selectedRole.value && selectedRole.value !== '') {
        filtered = filtered.filter(user =>
            user.roles.some(role => role.name.toLowerCase() === selectedRole.value.toLowerCase())
        );
        }

        const startIndex = (currentPage.value - 1) * usersPerPage.value;
        const endIndex = startIndex + usersPerPage.value;

        return filtered.slice(startIndex, endIndex);
    });
    const totalPages = computed(() => {
        const filteredTotal = users.value.filter(user =>
        user.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        user.email.toLowerCase().includes(searchQuery.value.toLowerCase())
        ).length;

        return Math.ceil(filteredTotal / usersPerPage.value);
    });

    const block_user = (user_id) => {
      selectedUserId.value = user_id; // Almacena el ID del usuario
      showBlockModal.value = true;     // Muestra el modal
    };

    const confirm_notify = () => {
      showNotifyModal.value = true;     // Muestra el modal
    };

    const delete_user = (user_id) => {
      selectedUserId.value = user_id; // Almacena el ID del usuario
      showDeleteModal.value = true;     // Muestra el modal
    };
    // Función para reenviar el correo
    const reenviar_email = async (userId) => {
      try {
        const options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`,
            'Content-Type': 'application/json'
          }
        };

        const data = { user_id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/broker/profile/resend-activation-email/${userId}`,
          data,
          options
        );

        // Verifica y ajusta esta condición según la respuesta real
        console.log('Respuesta del servidor:', response.data);

        if (response.status === 200) {
          showToast('Correo reenviado correctamente'); 
          showBlockModal.value = false; 
        } else {
          showToast('Hubo un error al reenviar.');
        }
      } catch (error) {
        console.error('Error al reenviar correo:', error);
        showToast('Hubo un error inesperado.');
      }
    };

    const confirmBlock = async () => {
        try {
        let options = {
            headers: {
            'Authorization': `Bearer ${session.value.token_api}`,
            'Content-Type': 'application/json'
            }
        };
        const data = { user_id_block: selectedUserId.value };
        const response = await axios.post(
            `${process.env.VUE_APP_API_BASE_URL}/broker/profile/block_user`, 
            data, 
            options
        );

        if (response.data.success) {
            showToast('Usuario bloqueado');  // Mostrar la notificación flotante de éxito
            showBlockModal.value = false;    // Cierra el modal
            fetchUsers();                    // Recargar la lista de usuarios
        } else {
            showToast('Hubo un error al bloquear el usuario. Intenta nuevamente.');
        }

        } catch (error) {
        console.error('Error al bloquear el usuario', error);
        showToast('Hubo un error al bloquear el usuario. Intenta nuevamente.');
        }
    };

    const confirmNotify = async () => {
      await closeModal();
      try {
        const options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`,
            'Content-Type': 'application/json'
          }
        };

        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/easybroker/leads`,
          options
        );

        if (response.data.success) {
          showToast('Asesores notificados con éxito.');
          fetchUsers();
          await closeModal();
        } else {
          showToast('Asesores notificados con éxito.');
          await closeModal();
        }
      } catch (error) {
        console.error('Error al notificar asesores:', error);
        showToast('Asesores notificados con éxito.');
        await closeModal();
      } 
    };

    const showToast = (message) => {
        successMessage.value = message;
        setTimeout(() => {
        successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
        }, 3000);
        };
        const confirmDelete = async () => {
        try {
        let options = {
            headers: {
            'Authorization': `Bearer ${session.value.token_api}`,
            'Content-Type': 'application/json',
            },
        };
        const data = { user_id_delete: selectedUserId.value };

        const response = await axios.post(
            `${process.env.VUE_APP_API_BASE_URL}/broker/profile/delete_user`, 
            data, 
            options
        );

        if (response.data.success) {
            showToast(response.data.message);  // Mostrar notificación flotante
            showDeleteModal.value = false;
            fetchUsers();
        } else {
            showToast('Hubo un error al eliminar el usuario. Intenta nuevamente.');
        }
        } catch (error) {
        console.error('Error al eliminar el usuario', error);
        showToast('Hubo un error al eliminar el usuario. Intenta nuevamente.');
        }
    };
    const closeModal = () => {
        showBlockModal.value = false; // Cierra el modal
        showDeleteModal.value = false; // Cierra el modal
        showNotifyModal.value = false; 
    };

    const goToUserForm = () => {
        router.push({ name: 'prospectos-form' });
    };

    const editUser = (id) => {
        console.log("ID del usuario:", id); // Imprime el ID en la consola
        router.push({ name: 'prospectos-form-edit', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
        menuVisible.value = null; // Cierra el menú después de hacer clic
    };

    const profileUser = (id) => {
        console.log("ID del usuario:", id); // Imprime el ID en la consola
        router.push({ name: 'AdvisorProfile', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
        menuVisible.value = null; // Cierra el menú después de hacer clic
    };

    const toggleMenu = (userId) => {
        menuVisible.value = menuVisible.value === userId ? null : userId;
    };

    // Manejo de clics fuera del menú
    const handleClickOutside = (event) => {
        if (!event.target.closest('.relative')) {
        menuVisible.value = null;
        }
    };

    // Lifecycle hooks
    onMounted(() => {
        fetchUsers();
        document.addEventListener('click', handleClickOutside);
    });

    onUnmounted(() => {
        document.removeEventListener('click', handleClickOutside);
    });
</script>

<style scoped>
  /* Ocultar tabla en mobile, mostrar cards */
  @media (max-width: 1023px) {
    .overflow-x-auto {
      display: none !important;
    }
  }

  /* Ocultar cards en desktop */
  @media (min-width: 1024px) {
    .lg\:hidden {
      display: none !important;
    }
  }
</style>